import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import _ from 'lodash';
import { IPortalConfig } from 'src/app/models';
import { CoreService, LoggingService, PortalService } from 'src/app/services';
import { Helpers } from 'src/app/helpers';
import { CalendarService } from 'src/app/services/calendar.service';

@Component({
    selector: 'medpt-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    standalone: false
})
export class DropdownComponent implements OnInit {
  @Input() field: any = {};
  @Input() form!: FormGroup;
  get isInValid() { return this.form.controls[this.field.uniquename].invalid; }
  get isTouched() { return this.form.controls[this.field.uniquename].touched; }
  get isDirty() { return this.form.controls[this.field.uniquename].dirty; }

  matDefaultItem = '-- Select an Answer --';
  defaultItem = { Answer: '-- Select an Answer --', FormAnswerID:'' };
  portalConfig!: IPortalConfig;
  filteredData: any[] = [];
  filterable: boolean = false;
  constructor(
    private coreService: CoreService,
    private portalService: PortalService,
    private cd: ChangeDetectorRef,
    private calendarService: CalendarService,
    private loggingService: LoggingService,
  ) {
    
  }

  ngOnInit(): void {
    this.portalConfig = this.portalService.portalConfiguation.getValue();

    if (this.isCustomDropdown) {
      this.filterable = true;
      this.field.Answers = [];
      this.filteredData = [];
      this.bindCustomDropdown();
    } else {
      this.filteredData = this.field.Answers;
      setTimeout(() => {
        this.cd.detectChanges();
      });
    }
  }

  get isCustomDropdown() {
    return this.field.MergeFieldName == 'SiteUsers'
      || this.field.MergeFieldName == 'SitePIs'
      || this.field.MergeFieldName == 'Country'
      || this.field.MergeFieldName == 'SiteNameDropDown'
      || this.field.QuestionType == 'Timezone';
  }

  private bindCustomDropdown() {

    if (this.field.MergeFieldName == "SiteUsers") {

      this.coreService.getSiteUsers(<string>this.portalConfig.SponsorName, <number>this.portalConfig.PortalID, <number>this.portalConfig.SiteId).then((result) => {
        this.BindSiteUserDropDown(result);
      });
      this.defaultItem = { Answer: '-- Select Site User --', FormAnswerID: '' };

    } else if (this.field.MergeFieldName == "SitePIs") {

      this.coreService.getSitePIUsers(<string>this.portalConfig.SponsorName, <number>this.portalConfig.PortalID, <number>this.portalConfig.SiteId).then((result) => {
        this.BindSiteUserDropDown(result);
      });
      this.defaultItem = { Answer: '-- Select Site PI --', FormAnswerID: '' };
    }
    else if (this.field.MergeFieldName == "Country") {

      this.coreService.getCountry(<string>this.portalConfig.SponsorName, <number>this.portalConfig.PortalID).then((result) => {
        this.filteredData = this.field.Answers = _.map(result, (item) => {
          return { Answer: Helpers.decodeEntity(item.CountryName), FormAnswerID: item.CountryID };
        });
        this.cd.detectChanges();
      });
      this.defaultItem = { Answer: '-- Select Country --', FormAnswerID: '' };
    }
    else if (this.field.MergeFieldName == "SiteNameDropDown") {

      this.coreService.getPortalSites(<string>this.portalConfig.SponsorName, <number>this.portalConfig.PortalID).then((result) => {
        this.filteredData = this.field.Answers = _.map(result, (item) => {
          return { Answer: Helpers.decodeEntity(item.SiteName), FormAnswerID: item.SiteID };
        });
        this.cd.detectChanges();
      });
      this.defaultItem = { Answer: '-- Select Site --', FormAnswerID: '' };
    }
    else if (this.field.QuestionType == "Timezone") {

      this.calendarService.getCalendarEventTimeZone().then((result:any) => {
        this.filteredData = this.field.Answers = _.map(result, (item) => {
          return { Answer: Helpers.decodeEntity(item.TimeZoneName + " (" + item.StandardName + ")"), FormAnswerID: item._TimeZoneID };
        });
        this.cd.detectChanges();
      });
      this.defaultItem = { Answer: '-- Select Timezone --', FormAnswerID: '' };
    }
  }
  public filterData(filter: any): void {
    this.filteredData = this.field.Answers.length > 0 ? this.field.Answers.filter((s:any) => s.Answer.toLowerCase().indexOf(filter.toLowerCase()) !== -1) : [];
  }

  private BindSiteUserDropDown(result: any): void {

    var answers = _.map(result, (item) => {

      let username = Helpers.decodeEntity(item.FirstName + ' ' + item.LastName);

      return { Answer: username, FormAnswerID: item.UserID };

    });

    if (!Helpers.isNullOrUndefined(this.field.response)) {

      var MatchedResponse = _.filter(answers, (item) => { return item.FormAnswerID == this.field.response.FormAnswerIDs; })

      if (MatchedResponse.length == 0) {

        answers.push({ Answer: this.field.response.ResponseChar, FormAnswerID: this.field.response.FormAnswerIDs });

      }

    }

    answers = _.orderBy(answers, [answer => answer.Answer.toLowerCase()], ['asc']);

    this.filteredData = this.field.Answers = answers;

    this.cd.detectChanges();

  }
 

}
